@if (service.bobo?.id) {
  <div>
    <span i18n="@@inv-invokeduser">Booking For </span>
    <span id="span-invoked-user-email">{{ service.bobo.email }}</span>
    @if (searchPage) {
      <button
        i18n="@@inv-cancel"
        (click)="clearBobo()"
        id="invoked-user-button-cancel"
        class="clear-bobo-btn"
      >
        Cancel
      </button>
    }
  </div>
}
